const $win = $(window)
const winHeight = $win.height()
const $images = $('.js-lazy-img')

/**
 * Update the src/style of lazy images
 * This should be used on scroll
 * @param  {Number} scroll is the window scroll position
 */
function loadLazyImages(scroll) {
  $images.each((idx, img) => {
    if (scroll + winHeight > $(img).offset().top) {
      loadImage($images[idx])
    }
  })
}

/**
 * Upate the src/style of the static lazy images
 * This should be used with slider images
 * @return {[type]} [description]
 */
function loadStaticLazyImages() {
  const $staticImages = $('.js-lazy-img-static')
  $staticImages.each((idx, img) => {
    loadImage(img)
  });
}

/**
 * Update the src/style of the item based on its tag
 * @param  {Node} img
 */
function loadImage(img) {
  if (img.tagName === 'IMG') {
    img.src = img.dataset.src

    return
  }

  img.style.backgroundImage = `url('${img.dataset.src}')`
}


$win.on('load', function(event) {
  loadStaticLazyImages()
});

$win.on('load scroll resize', function(event) {
  loadLazyImages($win.scrollTop())
});